import { NgModule } from "@angular/core"
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { GoogleMapsModule } from '@angular/google-maps';

// AgmCoreModule.forRoot({
//   apiKey: "AIzaSyBqzQML86N5ssHpP0G7H2vGz66pr_KmoXk",
//   libraries: ['places'],
//   clientId: '65be7e7aa72a07d4 '
// }),

const modules: any[] = [
  GoogleMapsModule,
  GooglePlaceModule
]

@NgModule({

  imports: [
    ...
    modules

  ],
  exports: [
    ...
    modules
  ]
})
export class AgmModule { }